import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

function Footer() {
  const footerLinks = {
    Explore: [
      { label: 'About Us', href: '/about' },
      { label: 'Paintings', href: '/paintings' },
      { label: 'Artist Directory', href: '/artists' },
      { label: 'Exhibitions', href: '/exhibitions' },
    ],
    Community: [
      { label: 'Communities', href: '/communities' },
      { label: 'Art Classes', href: '/art-classes' },
      { label: 'Pricing Calculator', href: '/pricing-calculator' },
      { label: 'How It Works', href: '/contact' },
    ],
    Support: [
      { label: 'Contact Us', href: '/contact' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms & Conditions', href: '/terms' },
    ],
  };

  return (
    <footer className="bg-navy-800 text-white pt-16 pb-8 border-t-[3px] border-gold-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="flex items-center justify-center bg-white/95 rounded-xl p-1.5 shadow-sm">
                <img src="/ck-logo-v2.png" alt="ChitraKalakar" className="h-10 w-auto object-contain" />
              </span>
              <div className="leading-none">
                <h3 className="font-serif text-xl font-semibold tracking-[0.06em]">
                  <span className="text-white">CHITRA</span>
                  <span className="text-gold-400">KALAKAR</span>
                </h3>
                <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-400/80 whitespace-nowrap">
                  Art · Inspiration · Infinite
                </p>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              A refined home for Indian art — connecting collectors and artists to create,
              commission, and celebrate timeless work.
            </p>
            <div className="space-y-2.5 text-sm text-white/70">
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-gold-400" strokeWidth={1.6} />
                <span>info@chitrakalakar.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-gold-400" strokeWidth={1.6} />
                <span>+91 98849 84454</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-gold-400" strokeWidth={1.6} />
                <span>India</span>
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold mb-4 text-white uppercase text-xs tracking-[0.18em] text-gold-400">{category}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-white/65 hover:text-gold-400 transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            {[
              { Icon: Facebook, href: 'https://facebook.com' },
              { Icon: Instagram, href: 'https://instagram.com' },
              { Icon: Twitter, href: 'https://twitter.com' },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/15 hover:border-gold-500 hover:bg-gold-500 hover:text-navy-800 text-white/70 transition-colors flex items-center justify-center"
              >
                <Icon className="w-4 h-4" strokeWidth={1.6} />
              </a>
            ))}
          </div>
          <p className="text-sm text-white/50">© 2025 ChitraKalakar by RamRath Global (GA). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
